// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1799L","text":"SelectPayment_text__zZjXZ","title":"SelectPayment_title__2uA2S","btn":"SelectPayment_btn__3nvJX"};